export {
  BackgroundColor,
  LayoutMinHeight,
  LayoutType,
} from './page-layout.component';
